import React, { Component, Fragment } from 'react';
import Scriba from 'react-scriba';
import { DataAzure } from '../../data/DataAzure.jsx';
import { EUIComboBox } from '../EUI/EUIComboBox';

export class ComboBoxIterationAzure extends Component {

    static defaultProps = {
        label: "Sprint Azure",
        placeholder: "Sprint Azure",
    };

    _onRenderOption = (props, defaultRender) => {
        const option = defaultRender(props);
        if (!!props && !!props.data) {
            const { startDate, finishDate } = props.data;
            return <Fragment>
                <span style={{ fontSize: ".8rem" }} className="badge badge-secondary mr-1">{props.text}</span>
                <span>{Scriba.date().stringDateFormatCourt(startDate)} ➔ {Scriba.date().stringDateFormatCourt(finishDate)}</span>
            </Fragment>;
        }
        else return option;
    };

    render = () => {

        const extractItems = (reponseAPIobjet) => {
            let items = EUIComboBox.defaultProps.extractItems(reponseAPIobjet);
            return items.sort((a, b) => new Date(b.attributes.startDate) - new Date(a.attributes.startDate));
        };

        const itemData = (item) => {
            const { attributes } = item;
            const { startDate, finishDate } = attributes || {};
            return { startDate, finishDate };
        };

        return <EUIComboBox
            {...this.props}
            extractItems={extractItems}
            fetchMethod={DataAzure._chargementIteration}
            itemData={itemData}
            itemKey={item => item.name}
            itemText={item => item.name}
            onRenderOption={this._onRenderOption}
            top={5}
        />;

    };

};